/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Row, Tabs,
} from 'antd';
import { FileTextOutlined, MenuUnfoldOutlined, UserOutlined } from '@ant-design/icons';
import { ESTATUS_AUTORIZADO, ESTATUS_CANCELADO } from 'utils/constants';
import VacantesCandidatos from '../Pruebas/VacantesCandidatos';
import ContratacionCandidatos from './ContratacionCandidatos';

function VacantesCandidatosMenu({ permission }) {
  const firstTab = 'candidatos';
  const secondTab = 'contratados';
  const thirdTab = 'viable_no_contratados';
  const fourthTab = 'viable_con_reserva';
  const fifthTab = 'no_viable';
  // const secondTab = 'pre_eliminar';
  const [currentParentTabKey, setCurrentParentTabKey] = useState(firstTab);
  const tabItems = [
    {
      key: firstTab,
      label: (
        <span>
          <MenuUnfoldOutlined />
          {' '}
          Candidatos
        </span>
      ),
      children: (
        <VacantesCandidatos
          permission={permission}
        />
      ),
      forceRender: true,
    },
    {
      key: secondTab,
      label: (
        <span>
          <FileTextOutlined />
          {' '}
          Contratados
        </span>
      ),
      children: (
        <ContratacionCandidatos
          permission={permission}
          estadoCandidato={7}
          contratacion_estados_globales={ESTATUS_AUTORIZADO}
        />
      ),
      forceRender: true,
    },
    {
      key: thirdTab,
      label: (
        <span>
          <UserOutlined />
          {' '}
          Viable No Contratado
        </span>
      ),
      children: (
        <ContratacionCandidatos
          permission={permission}
          psicometrico={1}
          contratacion_estados_globales={ESTATUS_CANCELADO}
        />
      ),
      forceRender: true,
    },
    {
      key: fourthTab,
      label: (
        <span>
          <UserOutlined />
          {' '}
          Viable Con Reserva
        </span>
      ),
      children: (
        <ContratacionCandidatos
          permission={permission}
          psicometrico={2}
        />
      ),
      forceRender: true,
    },
    {
      key: fifthTab,
      label: (
        <span>
          <UserOutlined />
          {' '}
          No Viable
        </span>
      ),
      children: (
        <ContratacionCandidatos
          permission={permission}
          psicometrico={3}
        />
      ),
      forceRender: true,
    },
  ];

  return (
    <Row className="container">

      <Tabs
        type="card"
        activeKey={currentParentTabKey || firstTab} // Evitar undefined
        onChange={setCurrentParentTabKey}
        items={tabItems}
      />
    </Row>
  );
}

export default VacantesCandidatosMenu;
